import type { AxiosResponse } from 'axios';

import type { Cookies } from 'commonTypes/api/cookiesService';
import { BFF_PROXY_API } from 'constants/apiRoutes';
import { COOKIE_NAMES } from 'constants/cookiesNames';

import { axiosWithoutRetries } from 'shared/api/requestInstance';
import { sendSentryClientErrorOnce } from 'shared/lib/sendSentryClientError';

import { COOKIE_DEFAULT_VALUE } from '../../constants';
import type { Base } from '../../types';

import { collectOrderAnalyticsFromCookies } from './collectOrderAnalyticsFromCookies';
import { getAnalyticsIds } from './getAnalyticsIds';
import { readUTMCookie } from './readUTMCookie';

export const collectOrderAnalytics = async (
  getCookie: (cookieName: string) => string | undefined,
  originalUrl: string,
  isWl: boolean,
): Promise<Base> => {
  const { clid, partner, promotionQuery, utm, deviceUUID } = collectOrderAnalyticsFromCookies(getCookie);
  let currentUtm = utm;

  const utmSource = currentUtm?.source;

  if (!utmSource || utmSource === COOKIE_DEFAULT_VALUE) {
    try {
      const { data } = await axiosWithoutRetries.get<
        Cookies.TUTMCookiesRequest,
        AxiosResponse<Cookies.TUTMCookiesResponse>
      >(BFF_PROXY_API.getUTMCookies, {
        params: {
          url: originalUrl,
        },
      });

      const utmCookiesString = data?.cookies?.find((cookie) => cookie.name === COOKIE_NAMES.utm)?.value || '';

      if (utmCookiesString) {
        currentUtm = readUTMCookie(utmCookiesString);
      }
    } catch (e) {
      sendSentryClientErrorOnce('ANALYTIC_ERROR', e, { clid, partner, promotionQuery, currentUtm });
    }
  }

  const { uaClientId, ymClientId } = getAnalyticsIds(isWl);

  currentUtm.uaClientId = uaClientId;
  currentUtm.ymClientId = ymClientId;

  return { clid, partner, promotionQuery, utm: currentUtm, deviceUUID };
};
